import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export default function ReportIssue() {
  const url =
    typeof window !== 'undefined'
      ? `${window.location.origin}${window.location.pathname}${window.location.search}${window.location.hash}`
      : '';
  const href =
    'mailto:support@vexi.co.za' +
    '?subject=' +
    encodeURIComponent('Vexi Issue Report') +
    '&body=' +
    encodeURIComponent(
      `Page: ${url}\n\nDescribe the issue you experienced:\n`
    );

  return (
    <div className="min-h-screen bg-background">
      <main className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
        <Link to="/search" className="text-sm text-muted-foreground hover:text-foreground hover:underline">
          ← Back to Search
        </Link>
        <h1 className="text-3xl sm:text-4xl font-heading font-bold text-foreground">
          Report an Issue
        </h1>

        <div className="mt-8 space-y-5 text-foreground/90 leading-relaxed">
          <p>If something isn’t working or you found a bug, let us know.</p>

          <div className="pt-2">
            <Button asChild className="rounded-full bg-primary hover:bg-primary/90">
              <a href={href}>Report an issue</a>
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}

